import { useState } from 'react';
import Materias from './Components/Materias';
import Totales from './Components/Totales';
import Adeudadas from './Components/Adeudadas';


function App() {
  const [calculado, setCalculado] = useState(0);
  const [electivas, setElectivas] = useState(0);
  const [adeudadas, setAudeudadas] = useState([]);
  return (
    <div className="container container-fluid">
      <div className='card m-3'>
        <div className='card-header text-center bg-primary'>
          Ingeniería en Sistemas de Información
        </div>
        <Materias 
          setCalculado={setCalculado}
          setElectivas={setElectivas}
          setAudeudadas={setAudeudadas}
        />
      </div>
      <Totales calculado={calculado}  electivas={electivas}/>
      {
        adeudadas.length>0 ?
          <Adeudadas adeudadas={adeudadas}  />
        :
          <span/>
      }
    </div>

  );
}

export default App;
